import { SelfbillStatus } from '../../../shared/objects/enum/selfbillStatus';
import { FieldDefinitionModel } from '../field-definition.model';
import { FilterSearch } from '../filter-search.model';
import { FilterModel } from '../filter.model';
import { SelfBillDefaultFilters } from './self-bill-default-filters';

export class SelfBillListFilters {
  public static statuses: FilterModel[] = [
    {
      value: '-',
      viewValue: '-',
      option: null,
    },
    {
      value: 'SELFBILL-STATUS.PORTAL',
      viewValue: 'SELFBILL-STATUS.PORTAL',
      option: SelfbillStatus.Portal,
    },
    {
      value: 'SELFBILL-STATUS.FINISHED',
      viewValue: 'SELFBILL-STATUS.FINISHED',
      option: SelfbillStatus.Finished,
    },
    {
      value: 'SELFBILL-STATUS.REJECTED',
      viewValue: 'SELFBILL-STATUS.REJECTED',
      option: SelfbillStatus.Rejected,
    },
  ];

  public static defaultFieldDefinitions: FieldDefinitionModel[] = [
    {
      type: 'select',
      name: 'status',
      placeholder: 'FILTERS.CHOOSE-STATUS',
      disabled: false,
      options: SelfBillListFilters.statuses,
      value: 'SELFBILL-STATUS.PORTAL',
    },
    {
      type: 'rangedatepicker',
      placeholder: 'FILTERS.CHOOSE-DATE-RANGE',
      name: 'dateRange',
    },
  ];

  public static defaultFields: SelfBillDefaultFilters = {
    dateRange: null,
    status: 'SELFBILL-STATUS.PORTAL',
  };

  public static filterSearch: FilterSearch = {
    filter: SelfBillListFilters.defaultFields,
    filterSearchValue: '',
  };
}
